import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
  ChartComponent,
  ApexLegend,
} from 'ng-apexcharts';

export type ChartOptions = {
  // series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  // labels: any;
  legend: ApexLegend;
};

@Component({
  selector: 'app-doughnut',
  templateUrl: './doughnut.component.html',
  styleUrl: './doughnut.component.css',
})
export class DoughnutComponent implements OnInit {
  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions> | any;

  // Custom variables to plot chart
  @Input('colors') colors: Partial<ChartOptions> | any ;
  @Input('customLabels') customLabels: Partial<ChartOptions> | any ;
  @Input('series') series: Partial<ChartOptions> | any ;

  ngOnInit(): void {
    this.chartOptions = {
      series: this.series,
      chart: {
        type: 'donut'
      },
      legend: {
        position: 'bottom',
      },
      dataLabels: {
        enabled: false,
      },
      labels: this.customLabels,
      colors: this.colors,
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 380,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    };
  }
}
